module.exports = __webpack_public_path__ + "media/images/flags/32/Algeria-2e63ac3d262faa0c5d4cba65867d9295.png";